import { create } from "zustand";

/**
 * Store de Zustand para datos del usuario autenticado
 * Persiste automáticamente en sessionStorage
 */
const useUserStore = create((set, get) => ({
  // Estado inicial
  user: {
    email: null,
    image: null,
    idUser: null,
    clientId: null,
  },

  /**
   * Inicializar el store desde sessionStorage
   * Llamar al montar la aplicación o después del login
   */
  initializeFromSession: () => {
    const email = sessionStorage.getItem("userEmail");
    const image = sessionStorage.getItem("userImage");
    const idUser = sessionStorage.getItem("idUser");
    const clientId = sessionStorage.getItem("clientId");

    set({
      user: {
        email: email || null,
        image: image || null,
        idUser: idUser || null,
        clientId: clientId || null,
      },
    });
  },

  /**
   * Actualizar datos del usuario
   * @param {Object} userData - Datos del usuario
   * @param {string} userData.email - Email del usuario
   * @param {string} userData.image - URL de la imagen del usuario/cliente
   * @param {string} userData.idUser - ID del usuario
   * @param {string} userData.clientId - ID del cliente
   */
  setUser: (userData) => {
    const newUser = {
      email: userData.email || get().user.email,
      image: userData.image || get().user.image,
      idUser: userData.idUser || get().user.idUser,
      clientId: userData.clientId || get().user.clientId,
    };

    // Actualizar store
    set({ user: newUser });

    // Persistir en sessionStorage
    if (newUser.email) sessionStorage.setItem("userEmail", newUser.email);
    if (newUser.image) sessionStorage.setItem("userImage", newUser.image);
    if (newUser.idUser) sessionStorage.setItem("idUser", newUser.idUser);
    if (newUser.clientId) sessionStorage.setItem("clientId", newUser.clientId);
  },

  /**
   * Actualizar solo la imagen del usuario
   * @param {string} image - URL de la imagen
   */
  setUserImage: (image) => {
    const currentUser = get().user;
    const updatedUser = { ...currentUser, image };

    set({ user: updatedUser });
    sessionStorage.setItem("userImage", image);
  },

  /**
   * Limpiar datos del usuario (para logout)
   */
  clearUser: () => {
    set({
      user: {
        email: null,
        image: null,
        idUser: null,
        clientId: null,
      },
    });

    // Limpiar sessionStorage
    sessionStorage.removeItem("userEmail");
    sessionStorage.removeItem("userImage");
    sessionStorage.removeItem("idUser");
    sessionStorage.removeItem("clientId");
  },

  /**
   * Obtener la imagen del usuario
   * @returns {string|null} URL de la imagen o null
   */
  getUserImage: () => {
    return get().user.image;
  },
}));

export default useUserStore;
